import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { ACTION, ACTION_SUBJECT, ACTION_SUBJECT_ID, EVENT_TYPE } from '@atlaskit/editor-common/analytics';
import { copyDomNode, toDOM } from '@atlaskit/editor-common/copy-button';
import { findSelectedNodeOfType, removeParentNodeOfType, removeSelectedNode } from '@atlaskit/editor-prosemirror/utils';
import { canBeConvertedToSyncBlock, findSyncBlock, findSyncBlockOrBodiedSyncBlock, isBodiedSyncBlockNode } from '../pm-plugins/utils/utils';
export var createSyncedBlock = function createSyncedBlock(_ref) {
  var tr = _ref.tr,
    syncBlockStore = _ref.syncBlockStore,
    typeAheadInsert = _ref.typeAheadInsert;
  var _tr$doc$type$schema$n = tr.doc.type.schema.nodes,
    bodiedSyncBlock = _tr$doc$type$schema$n.bodiedSyncBlock,
    paragraph = _tr$doc$type$schema$n.paragraph;

  // If the selection is empty, we want to insert the sync block on a new line
  if (tr.selection.empty) {
    var storeSyncBlockNode = syncBlockStore.createSyncBlockNode();
    var paragraphNode = paragraph.createAndFill({});
    var newBodiedSyncBlockNode = bodiedSyncBlock.createAndFill(_objectSpread({}, storeSyncBlockNode.attrs), paragraphNode ? [paragraphNode] : []);
    if (!newBodiedSyncBlockNode) {
      return false;
    }
    if (typeAheadInsert) {
      tr = typeAheadInsert(newBodiedSyncBlockNode);
    } else {
      tr = tr.replaceSelectionWith(newBodiedSyncBlockNode).scrollIntoView();
    }
  } else {
    var conversionInfo = canBeConvertedToSyncBlock(tr.selection);
    if (!conversionInfo) {
      // TODO: EDITOR-1665 - Raise an error analytics event
      return false;
    } else {
      var _storeSyncBlockNode = syncBlockStore.createSyncBlockNode();
      var _newBodiedSyncBlockNode = bodiedSyncBlock.createAndFill(_objectSpread({}, _storeSyncBlockNode.attrs), conversionInfo.contentToInclude);
      if (!_newBodiedSyncBlockNode) {
        return false;
      }
      tr.replaceWith(conversionInfo.from - 1, conversionInfo.to, _newBodiedSyncBlockNode).scrollIntoView();
    }
  }
  return tr;
};
export var copySyncedBlockReferenceToClipboard = function copySyncedBlockReferenceToClipboard(api) {
  return function (state, _dispatch, _view) {
    if (!(api !== null && api !== void 0 && api.floatingToolbar)) {
      return false;
    }
    var syncBlockFindResult = findSyncBlockOrBodiedSyncBlock(state);
    if (!syncBlockFindResult) {
      return false;
    }
    var isBodiedSyncBlock = isBodiedSyncBlockNode(syncBlockFindResult.node, state.schema.nodes.bodiedSyncBlock);
    var referenceSyncBlockNode = null;
    if (isBodiedSyncBlock) {
      var syncBlock = state.tr.doc.type.schema.nodes.syncBlock;

      // create sync block reference node
      referenceSyncBlockNode = syncBlock.createAndFill({
        resourceId: syncBlockFindResult.node.attrs.resourceId
      });
      if (!referenceSyncBlockNode) {
        return false;
      }
    } else {
      referenceSyncBlockNode = syncBlockFindResult.node;
    }
    if (!referenceSyncBlockNode) {
      return false;
    }
    var domNode = toDOM(referenceSyncBlockNode, state.tr.doc.type.schema);
    copyDomNode(domNode, referenceSyncBlockNode.type, state.tr.selection);
    return true;
  };
};
export var editSyncedBlockSource = function editSyncedBlockSource(syncBlockStore, api) {
  return function (state, dispatch, _view) {
    var _syncBlock$node;
    var syncBlock = findSyncBlock(state);
    var resourceId = syncBlock === null || syncBlock === void 0 || (_syncBlock$node = syncBlock.node) === null || _syncBlock$node === void 0 || (_syncBlock$node = _syncBlock$node.attrs) === null || _syncBlock$node === void 0 ? void 0 : _syncBlock$node.resourceId;
    if (!resourceId) {
      return false;
    }
    var syncBlockURL = syncBlockStore.getSyncBlockURL(resourceId);
    if (syncBlockURL) {
      window.open(syncBlockURL, '_blank');
    } else {
      var _api$analytics;
      var tr = state.tr;
      api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 || (_api$analytics = _api$analytics.actions) === null || _api$analytics === void 0 || _api$analytics.attachAnalyticsEvent({
        eventType: EVENT_TYPE.OPERATIONAL,
        action: ACTION.ERROR,
        actionSubject: ACTION_SUBJECT.SYNCED_BLOCK,
        actionSubjectId: ACTION_SUBJECT_ID.SYNCED_BLOCK_SOURCE_URL,
        attributes: {
          error: 'No URL resolved for synced block'
        }
      })(tr);
      dispatch === null || dispatch === void 0 || dispatch(tr);
    }
    return true;
  };
};
export var removeSyncedBlock = function removeSyncedBlock(api) {
  return function (state, dispatch, _view) {
    var nodes = state.schema.nodes,
      tr = state.tr;
    if (!dispatch) {
      return false;
    }
    var removeTr = tr;
    if (findSelectedNodeOfType(nodes.syncBlock)(tr.selection) || findSelectedNodeOfType(nodes.bodiedSyncBlock)(tr.selection)) {
      removeTr = removeSelectedNode(tr);
    } else {
      removeTr = removeParentNodeOfType(nodes.bodiedSyncBlock)(tr);
    }
    if (!removeTr) {
      return false;
    }
    dispatch(removeTr);
    api === null || api === void 0 || api.core.actions.focus();
    return true;
  };
};